import { EMPTY_LIST } from '../../../../constants/common'

// Dividers are not registered in the floating list, so `activeIndex` counts only real items
export function getNavigableSelectOptions(options) {
  return (options ?? EMPTY_LIST).filter(option => !option.Divider)
}
